
import { Link } from 'react-router-dom';

export default function Career() {
  const jobCategories = [
    {
      title: '調剤薬局',
      description: '地域密着型の調剤薬局での薬剤師業務',
      icon: 'ri-store-line',
      color: 'bg-blue-50 text-blue-600',
      positions: ['管理薬剤師', '薬剤師', 'パート薬剤師'],
      salary: '年収400-600万円'
    },
    {
      title: '病院薬剤師',
      description: '病院内での薬剤管理・服薬指導業務',
      icon: 'ri-hospital-line',
      color: 'bg-red-50 text-red-600',
      positions: ['病棟薬剤師', 'DI薬剤師', '薬剤部管理職'],
      salary: '年収450-700万円'
    },
    {
      title: 'ドラッグストア',
      description: 'OTC販売・健康相談・調剤業務',
      icon: 'ri-shopping-bag-line',
      color: 'bg-green-50 text-green-600',
      positions: ['店舗薬剤師', '店長候補', 'エリアマネージャー'],
      salary: '年収500-800万円'
    },
    {
      title: '製薬企業',
      description: '新薬開発・学術・MR業務',
      icon: 'ri-flask-line',
      color: 'bg-purple-50 text-purple-600',
      positions: ['開発職', '学術職', 'MR', '薬事職'],
      salary: '年収600-1000万円'
    },
    {
      title: '派遣薬剤師',
      description: '柔軟な働き方で高時給を実現',
      icon: 'ri-time-line',
      color: 'bg-orange-50 text-orange-600',
      positions: ['調剤薬局派遣', '病院派遣', 'ドラッグストア派遣'],
      salary: '時給3000-4500円'
    }
  ];

  const careerSteps = [
    {
      step: '1',
      title: 'キャリア相談',
      description: '専門コンサルタントがあなたのキャリアプランをサポート',
      icon: 'ri-user-heart-line'
    },
    {
      step: '2',
      title: '求人紹介',
      description: 'あなたの希望に合った求人を厳選してご紹介',
      icon: 'ri-search-line'
    },
    {
      step: '3',
      title: '面接対策',
      description: '面接のポイントや履歴書作成をサポート',
      icon: 'ri-presentation-line'
    },
    {
      step: '4',
      title: '転職成功',
      description: '内定獲得から入職まで全面的にサポート',
      icon: 'ri-trophy-line'
    }
  ];

  const benefits = [
    {
      title: '非公開求人多数',
      description: '一般には公開されていない優良求人をご紹介',
      icon: 'ri-lock-line'
    },
    {
      title: '完全無料サービス',
      description: 'すべてのサービスを無料でご利用いただけます',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      title: '専門コンサルタント',
      description: '薬剤師業界に精通したコンサルタントが対応',
      icon: 'ri-user-star-line'
    },
    {
      title: '転職後フォロー',
      description: '転職後も継続的にキャリアをサポート',
      icon: 'ri-customer-service-line'
    }
  ];

  const quickAccessItems = [
    {
      title: '緊急時対応',
      description: '災害時の薬剤師活動、モバイルファーマシー、DMAT連携',
      icon: 'ri-emergency-line',
      color: 'bg-red-50 text-red-600',
      link: '/emergency'
    },
    {
      title: '公的機関リンク',
      description: '厚生労働省、PMDA、日本薬剤師会の最新情報',
      icon: 'ri-information-line',
      color: 'bg-blue-50 text-blue-600',
      link: '/official-links'
    },
    {
      title: '医薬品購入サイト',
      description: '信頼できる医薬品・医療機器の購入サイト情報',
      icon: 'ri-shopping-cart-line',
      color: 'bg-green-50 text-green-600',
      link: '/medical-purchase'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <div className="w-10 h-10 mr-3 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-lg transform rotate-12 shadow-lg"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-lg"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </Link>
            </div>
            <nav className="hidden md:flex space-x-6">
              <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">サービス</Link>
              <Link to="/health-support" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">健康サポート</Link>
              <Link to="/pharmacist-resources" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬剤師向け</Link>
              <Link to="/information" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">情報提供</Link>
              <Link to="/package-insert-search" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">添付文書検索</Link>
              <Link to="/drug-price-search" className="text-gray-700 hover:text-teal-600 font-medium whitespace-nowrap cursor-pointer">薬価サーチ</Link>
            </nav>
            <button className="md:hidden p-2">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 to-blue-50 py-20">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/ede4bc9d07c1351a232b7dce08698b04.jpg"
            alt="薬剤師キャリア"
            className="w-full h-full object-cover object-top opacity-20"
          />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            薬剤師<span className="text-teal-600">転職・派遣・キャリア</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            あなたの理想のキャリアを実現するための転職・派遣サポートサービス
          </p>
        </div>
      </section>

      {/* Affiliate Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">薬剤師転職・派遣サポートサービス</h2>
          <p className="text-lg text-gray-600 mb-8">
            信頼と実績のサービスで理想のキャリアを実現しませんか
          </p>

          {/* ファルマスタッフ Section */}
          <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-xl p-8 max-w-4xl mx-auto mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">薬剤師の転職＆派遣ならファルマスタッフ</h3>
            <div className="flex justify-center mb-6">
              <a href="https://px.a8.net/svt/ejp?a8mat=45FWLX+3L731U+276A+67JU9" rel="nofollow" className="cursor-pointer">
                <img border="0" width="336" height="280" alt="ファルマスタッフ" src="https://www20.a8.net/svt/bgt?aid=251004885217&wid=001&eno=01&mid=s00000010261001043000&mc=1" />
              </a>
              <img border="0" width="1" height="1" src="https://www17.a8.net/0.gif?a8mat=45FWLX+3L731U+276A+67JU9" alt="" className="hidden" />
            </div>
            <div className="bg-white rounded-xl p-6 mb-6">
              <h4 className="text-xl font-bold text-gray-900 mb-4">ファルマスタッフの薬剤師の特徴</h4>
              <div className="grid md:grid-cols-3 gap-6 text-left">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-award-line text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">業界トップクラス</h5>
                    <p className="text-gray-600 text-sm">豊富な求人数と実績で安心のサポート</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-time-line text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">派遣に強い</h5>
                    <p className="text-gray-600 text-sm">柔軟な働き方を実現する派遣求人が充実</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-customer-service-line text-sm"></i>
                  </div>
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">手厚いサポート</h5>
                    <p className="text-gray-600 text-sm">転職から就業後まで継続的にフォロー</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* アポプラス薬剤師 */}
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-8 border border-blue-100">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">アポプラス薬剤師</h3>
                <p className="text-gray-600">信頼と実績の薬剤師転職支援</p>
              </div>
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-briefcase-line text-2xl text-blue-600"></i>
              </div>
            </div>
            
            <div className="grid md:grid-cols-3 gap-4 mb-6">
              <div className="text-center p-4 bg-white rounded-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-award-line text-xl text-blue-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">信頼の実績</h4>
                <p className="text-sm text-gray-600">20年以上の実績と豊富な転職成功事例</p>
              </div>
              <div className="text-center p-4 bg-white rounded-lg">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-user-heart-line text-xl text-purple-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">専任コンサルタント</h4>
                <p className="text-sm text-gray-600">薬剤師専門のキャリアアドバイザーがサポート</p>
              </div>
              <div className="text-center p-4 bg-white rounded-lg">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-map-pin-line text-xl text-green-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">全国対応</h4>
                <p className="text-sm text-gray-600">地方での転職もしっかりサポート</p>
              </div>
            </div>
            
            <div className="text-center">
              <a href="https://px.a8.net/svt/ejp?a8mat=45FWLX+3KLNG2+52EE+5ZMCH" rel="nofollow" target="_blank" className="inline-block">
                <img border="0" width="300" height="250" alt="アポプラス薬剤師" src="https://www21.a8.net/svt/bgt?aid=251004885216&wid=001&eno=01&mid=s00000023639001006000&mc=1" className="rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300" />
              </a>
              <img border="0" width="1" height="1" src="https://www10.a8.net/0.gif?a8mat=45FWLX+3KLNG2+52EE+5ZMCH" alt="" />
            </div>
          </div>

        </div>
      </section>

      {/* Job Categories */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">求人カテゴリー</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {jobCategories.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6 border border-gray-100">
                <div className={`w-16 h-16 ${category.color} rounded-xl flex items-center justify-center mb-4`}>
                  <i className={`${category.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{category.title}</h3>
                <p className="text-gray-600 mb-4">{category.description}</p>
                <div className="mb-4">
                  <p className="text-sm font-medium text-gray-700 mb-2">主な職種:</p>
                  <div className="flex flex-wrap gap-1">
                    {category.positions.map((position, posIndex) => (
                      <span key={posIndex} className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">
                        {position}
                      </span>
                    ))}
                  </div>
                </div>
                <p className="text-teal-600 font-semibold">{category.salary}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Dispatch Information Section */}
      <section className="py-16 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">派遣薬剤師という働き方</h2>
            <p className="text-lg text-gray-600">柔軟性と高収入を両立できる新しいキャリアスタイル</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">派遣薬剤師のメリット</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-money-yen-circle-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">高時給を実現</h4>
                    <p className="text-gray-600">時給3000-4500円の高収入。正社員より効率的に稼げます</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">柔軟な働き方</h4>
                    <p className="text-gray-600">勤務日数や時間を自由に調整。プライベートとの両立が可能</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-map-pin-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">勤務地を選択</h4>
                    <p className="text-gray-600">希望エリアでの勤務が可能。転居の必要がありません</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-book-open-line text-sm"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">多様な経験</h4>
                    <p className="text-gray-600">様々の職場で経験を積み、スキルアップが図れます</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20female%20pharmacist%20working%20flexibly%20with%20laptop%20and%20medicine%2C%20modern%20pharmacy%20setting%2C%20work-life%20balance%20concept%2C%20happy%20and%20confident%20expression%2C%20bright%20professional%20atmosphere%2C%20flexible%20working%20environment&width=500&height=400&seq=dispatch-pharmacist&orientation=landscape"
                alt="派遣薬剤師の働き方"
                className="w-full max-w-md rounded-xl shadow-lg"
              />
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">派遣薬剤師に向いている方</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-parent-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">子育て中の方</h4>
                <p className="text-gray-600 text-sm">育児と仕事を両立したい薬剤師の方に最適</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-graduation-cap-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">スキルアップ志向</h4>
                <p className="text-gray-600 text-sm">多様な職場で経験を積みたい方</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-compass-line text-2xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">自由度重視</h4>
                <p className="text-gray-600 text-sm">自分のペースで働きたい方</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Career Steps */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">転職サポートの流れ</h2>
          <div className="grid md:grid-cols-4 gap-8">
            {careerSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${step.icon} text-2xl`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center text-sm font-bold">
                    {step.step}
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">サービスの特徴</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 text-center">
                <div className="w-12 h-12 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">転職成功事例</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">A.Sさん（28歳）</h3>
                  <p className="text-sm text-gray-600">調剤薬局 → 病院薬剤師</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                「病棟業務に興味があり転職を決意。専門コンサルタントのサポートで希望の病院に転職できました。」
              </p>
              <div className="text-teal-600 font-semibold">年収：450万円 → 520万円</div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 text-green-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">M.Tさん（35歳）</h3>
                  <p className="text-sm text-gray-600">ドラッグストア → 製薬企業</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                「キャリアアップを目指して製薬企業へ。面接対策が充実していて安心でした。」
              </p>
              <div className="text-teal-600 font-semibold">年収：550万円 → 720万円</div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-line text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">K.Yさん（42歳）</h3>
                  <p className="text-sm text-gray-600">病院 → 管理薬剤師</p>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                「管理職を目指していたところ、理想的な調剤薬局の管理薬剤師ポジションを紹介していただきました。」
              </p>
              <div className="text-teal-600 font-semibold">年収：600万円 → 680万円</div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Access Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">クイックアクセス</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {quickAccessItems.map((item, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg p-6">
                <div className={`w-12 h-12 ${item.color} rounded-lg flex items-center justify-center mb-4`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <Link to={item.link} className="text-teal-600 font-medium hover:text-teal-700 cursor-pointer">詳細を見る →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 mr-2 relative">
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-400 to-emerald-400 rounded-lg transform rotate-12"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-300 to-emerald-300 rounded-lg flex items-center justify-center">
                    <i className="ri-heart-pulse-fill text-white text-sm"></i>
                  </div>
                </div>
                <div className="text-xl font-bold text-teal-400" style={{ fontFamily: '"Pacifico", serif' }}>
                  みんなの薬局～Pharmacare～
                </div>
              </div>
              <p className="text-gray-400">
                患者さんと薬剤師をつなぐ総合医療情報プラットフォーム
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">患者さん向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/health-consultation" className="hover:text-white cursor-pointer">健康相談</Link></li>
                <li><Link to="/self-care" className="hover:text-white cursor-pointer">セルフケア</Link></li>
                <li><Link to="/otc" className="hover:text-white cursor-pointer">OTC医薬品</Link></li>
                <li><Link to="/kampo" className="hover:text-white cursor-pointer">漢方相談</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">薬剤師向け</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/sterile-preparation" className="hover:text-white cursor-pointer">無菌調剤</Link></li>
                <li><Link to="/home-care" className="hover:text-white cursor-pointer">在宅医療</Link></li>
                <li><Link to="/online-guidance" className="hover:text-white cursor-pointer">オンライン服薬指導</Link></li>
                <li><Link to="/dx" className="hover:text-white cursor-pointer">薬局DX</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">情報・リンク</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/official-links" className="hover:text-white cursor-pointer">公的機関リンク</Link></li>
                <li><Link to="/guidelines" className="hover:text-white cursor-pointer">疾患ガイドライン</Link></li>
                <li><Link to="/career" className="hover:text-white cursor-pointer">薬剤師転職・派遣・キャリア情報</Link></li>
                <li><Link to="/entertainment" className="hover:text-white cursor-pointer">エンタメ</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Web Design</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
